import React from "react";
import { Alert } from "react-bootstrap";
import { ReactComponent as DangerCircleSVG } from "go-core/images/svg/alert.svg";

interface Props {
	message: string;
}
const LiveOrderListItemErrorNotification = ({ message }: Props) => {
	return (
		<Alert variant="danger" className="live-orders-error-notification">
			<div className="d-flex">
				<DangerCircleSVG />
				<span>{message}</span>
			</div>
		</Alert>
	);
};

export default LiveOrderListItemErrorNotification;
